import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormField } from '../models/form.model';

@Component({
  selector: 'app-form-image-display-field',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="form-group image-display-field">
      <label *ngIf="field.label" class="form-label">{{ field.label }}</label>
      <img 
        *ngIf="field.defaultValue && !imageError" 
        [src]="field.defaultValue" 
        class="img-fluid rounded" 
        [alt]="field.label || 'Display image'"
        (error)="onImageError($event)" />
      <div *ngIf="imageError" class="text-muted small">
        <em>Image could not be loaded</em>
      </div>
    </div>
  `,
  styles: [`
    .image-display-field { margin-bottom: 1.5rem; }
    .form-label { font-weight: 500; display: block; margin-bottom: 0.5rem; }
    .img-fluid { max-width: 100%; height: auto; display: block; }
    .rounded { border-radius: 0.25rem; }
  `]
})
export class FormImageDisplayFieldComponent implements OnInit {
  @Input() field!: FormField;
  @Input() value: string | undefined; // Not used
  @Output() valueChange = new EventEmitter<string>(); // Never emits
  @Output() errorChange = new EventEmitter<any>(); // Always emits null

  imageError = false;

  ngOnInit(): void {
    this.errorChange.emit(null); // No validation for display-only
  }

  onImageError(event: Event): void {
    this.imageError = true;
    console.warn('[ImageDisplayField] Failed to load image:', this.field.defaultValue);
  }
}
